import FournisseurForm from "../Fournisseur/FournisseurForm";
import "./ReceptionCompact.css";
import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { receiptNoteActions } from '../../sagas/receiptNoteSlice';
import Swal from 'sweetalert2';
import { formatPrice } from '../../helpers/utility';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { components } from 'react-select';
import { supplierActions } from '../../sagas/supplierSlice';
import { FaArrowLeft, FaMoneyBillWave, FaPlus, FaUser } from 'react-icons/fa';
import ReceptionLines from './ReceptionLines';
import { useLocation, useNavigate } from 'react-router-dom';
import { entrepotActions } from '../../sagas/entrepotSlice';
import { purchaseActions } from '../../sagas/purchaseSlice';

import '../shared/DocumentForm.css';

const ReceiptNoteNew = ({ onClose, reception, initialValues, purchaseOrder }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const routeState = location.state || {};
    const activePurchaseOrder = purchaseOrder || routeState.purchaseOrder || null;
    const sourceReception = reception || initialValues || routeState.reception || routeState.initialValues || {};
    const [discountLockedFromPurchase, setDiscountLockedFromPurchase] = useState(
        Boolean(sourceReception.commandeId && Number(sourceReception.montantRemise || activePurchaseOrder?.montantRemise || 0) > 0)
    );
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const { company } = useSelector(statut => statut.auth);
    const { purchases, loading } = useSelector((state) => state.purchases);
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const closeForm = () => {
        if (onClose) {
            onClose();
            return;
        }

        navigate(routeState.returnTo || '/purchases-module/reception', {
            state: routeState.returnState,
        });
    };

    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: null,
        dateTo: null,
        query: ''
    });

    const { entrepots } = useSelector(state => state.entrepots);


    useEffect(() => {
        let payload = {
            ...filters,
            notReceptioned: true,
        };
        dispatch(purchaseActions.search(payload));

        dispatch(supplierActions.search({
            query: ""
        }));

    }, []);

    useEffect(() => {
    }, [suppliers, purchases])


    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    const poOptions = !loading ? purchases?.map(po => ({
        fournisseurId: po.fournisseurId,
        fournisseurNom: po.fournisseurNom,
        numeroCheque: po.numeroCheque,
        lignes: po.lignes,
        montantTotalHT: po.montantTotalHT,
        montantTotalAvantRemise: po.montantTotalAvantRemise || po.montantTotalTTC,
        montantRemise: po.montantRemise || 0,
        montantTotalTTC: po.montantTotalTTC,
        montantTotalTaxe: po.montantTotalTaxe,
        modeReglement: po.modeReglement,
        commandeId: po.id,
        value: po.numero,
        label: `${po.numero} - ${po.fournisseurNom}`
    })) : [];

    const formik = useFormik({
        initialValues: {
            fournisseurId: sourceReception.fournisseurId || null,
            fournisseurNom: sourceReception.fournisseurNom || '',
            deliveryNoteNb: sourceReception.deliveryNoteNb || '',
            dateReception: sourceReception.dateReception || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            dateOperation: sourceReception.dateOperation || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            lignes: sourceReception.lignes || [],
            montantTotalHT: sourceReception.montantTotalHT || 0,
            montantTotalAvantRemise: sourceReception.montantTotalAvantRemise ?? ((Number(sourceReception.montantTotalTTC) || 0) + (Number(sourceReception.montantRemise) || 0)),
            montantRemise: sourceReception.montantRemise || 0,
            montantTotalTTC: sourceReception.montantTotalTTC || 0,
            montantTotalTaxe: sourceReception.montantTotalTaxe || 0,
            statut: sourceReception.statut || 'EN_ATTENTE',
            modeReglement: sourceReception.modeReglement || 'ESPECES',
            numeroCheque: sourceReception.numeroCheque,
            addresseLivraison: sourceReception.addresseLivraison || company.adresse,
            entrepotId: sourceReception.entrepotId || null,
            commandeNumero: sourceReception.commandeNumero || '',
            commandeId: sourceReception.commandeId || null,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fournisseurId: Yup.number().required(t('reception.supplierMissing', 'Supplier is required')),
            deliveryNoteNb: Yup.string().required(t('reception.deliveryNoteMissing', 'Delivery note number is required')),
            lignes: Yup.array().of(
                Yup.object().shape({
                    id: Yup.number(),
                    // prixUnitaireHT: Yup.number()
                    //     .min(1, t('reception.unitPriceMinValue', 'Unit price must be at least 1'))
                    //     .required(t('reception.unitPriceMissing', 'Unit price is required')),
                    quantiteRecue: Yup.number()
                        .min(1, t('reception.receivedQuantityMinValue', 'Received quantity must be at least 1'))
                        .required(t('reception.receivedQuantityMissing', 'Received quantity is required')),
                })
            ).min(1, t('reception.atLeastOneLine', 'At least one line is required')),
            entrepotId: Yup.number().required(t('reception.entrepotMissing', 'Entrepot is required')),
        }),


        onSubmit: (values) => {
            if (!values.deliveryNoteNb) {
                Swal.fire({
                    icon: 'warning',
                    title: t('reception.missingDeliveryNoteTitle', 'Missing Delivery Note Number'),
                    text: t('reception.missingDeliveryNoteMessage', 'Please enter a delivery note number before submitting.'),
                    confirmButtonText: t('common.ok', 'OK')
                });
                return; // Stop the submission process
            }

            Swal.fire({
                title: 'Enregistrer la réception ?',
                text: 'Confirmer ajoute les marchandises au stock. Garder en attente permet de modifier plus tard.',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Enregistrer et ajouter au stock',
                denyButtonText: 'Garder en attente',
                cancelButtonText: t('common.cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    values.statut = 'VALIDE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (sourceReception.id) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: sourceReception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                } else if (result.isDenied) {
                    values.statut = 'EN_ATTENTE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (sourceReception.id) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: sourceReception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                }
            });
        },
    });

    const { values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

    const roundMoney = (value, decimals = 2) => Number(
        Math.round((Number(value) + Number.EPSILON) * Math.pow(10, decimals)) /
        Math.pow(10, decimals)
    );

    const handleDiscountChange = (event) => {
        const grossTotal = Number(values.montantTotalAvantRemise || values.montantTotalTTC || 0);
        const discount = Math.max(0, Math.min(Number(event.target.value) || 0, grossTotal));

        setFieldValue('montantRemise', discount);
        setFieldValue('montantTotalTTC', Math.max(0, roundMoney(grossTotal - discount)));
    };


    const handlePurchaseOrderChange = (selectedOption) => {
        console.log(selectedOption)
        if (selectedOption) {
            setFieldValue('commandeId', selectedOption.commandeId);
            setFieldValue('commandeNumero', selectedOption.value);
            setFieldValue('fournisseurId', selectedOption.fournisseurId);
            setFieldValue('fournisseurNom', selectedOption.fournisseurNom);
            setFieldValue('lignes', selectedOption.lignes.map(line => ({
                articleId: line.articleId,
                articleNom: line.articleNom,
                quantiteCommandee: line.quantiteCommandee,
                quantiteRecue: line.quantiteCommandee,
                prixUnitaireHT: line.prixUnitaireHT,
                prixUnitaireTTC: line.prixUnitaireTTC,
                montantHT: line.montantHT,
                tauxTVA: line.tauxTVA,
                unite: line.unite,
                montantTTC: line.montantTTC
            })));

            setFieldValue('montantTotalHT', selectedOption.montantTotalHT);
            setFieldValue('montantTotalAvantRemise', selectedOption.montantTotalAvantRemise || selectedOption.montantTotalTTC);
            setFieldValue('montantRemise', selectedOption.montantRemise || 0);
            setFieldValue('montantTotalTTC', selectedOption.montantTotalTTC);
            setFieldValue('montantTotalTaxe', selectedOption.montantTotalTaxe);
            setFieldValue('numeroCheque', selectedOption.numeroCheque);
            setFieldValue('modeReglement', selectedOption.modeReglement);
            setDiscountLockedFromPurchase(Number(selectedOption.montantRemise || 0) > 0);
        } else {
            setFieldValue('montantTotalHT', 0);
            setFieldValue('montantTotalAvantRemise', 0);
            setFieldValue('montantRemise', 0);
            setFieldValue('montantTotalTTC', 0);
            setFieldValue('montantTotalTaxe', 0);
            setDiscountLockedFromPurchase(false);

            setFieldValue('commandeId', null);
            setFieldValue('commandeNumero', '');
            setFieldValue('fournisseurId', null);
            setFieldValue('numeroCheque', null);
            setFieldValue('modeReglement', null);
            setFieldValue('fournisseurNom', '');
            setFieldValue('lignes', []);
        }

    };

    useEffect(() => {
        dispatch(entrepotActions.list());
    }, []);

    const handleCreateSupplier = () => {
        setShowSupplierModal(true);
    };

    const handleSupplierChange = (selectedOption) => {
        formik.setFieldValue('lignes', []); // Clear the lignes when the supplier changes
        formik.setFieldValue('fournisseurId', selectedOption?.value || null);
        formik.setFieldValue('fournisseurNom', selectedOption?.label || '');
        formik.setFieldValue('montantTotalTTC', 0);
        formik.setFieldValue('montantTotalHT', 0);
        formik.setFieldValue('montantTotalTaxe', 0);
        formik.setFieldValue('montantTotalAvantRemise', 0);
        formik.setFieldValue('montantRemise', 0);
        setDiscountLockedFromPurchase(false);
    };




    const entrepotOptions = entrepots?.map(entrepot => ({
        value: entrepot.id,
        label: entrepot.code + ' - ' + entrepot.libelle,
    })) ?? [];



    return (
    <Container fluid className="document-form-page reception-compact reception-form py-2">
        <Card className="document-form-card">
            <CardHeader className="document-form-header">
                <div className="document-form-title-row">
                    <div>
                        <h4 className="mb-1">
                            {sourceReception?.id ? `Réception ${sourceReception.numero || ''}` : 'Recevoir des marchandises'}
                        </h4>
                        <div className="text-muted small">Choisissez le fournisseur, ajoutez les articles, puis enregistrez.</div>
                    </div>
                    <div className="document-form-header-actions">
                        <Button type="button" color="light" className="document-form-return" onClick={closeForm}>
                            <FaArrowLeft className="me-2" />
                            {t('common.return')}
                        </Button>
                    </div>
                </div>
            </CardHeader>
            <CardBody className="document-form-body">
        <Form onSubmit={handleSubmit} className="document-form">
            <section className="document-form-section">
                <div className="document-form-section-title">1. Fournisseur et livraison</div>
            <Row className="g-2">
                <Col md="3">
                    {reception ? <FormGroup>
                        <Label>Commande existante (facultatif)</Label>
                        <Input
                            type="text"
                            name="commandeNumero"
                            {...getFieldProps('commandeNumero')}
                            disabled
                        />
                    </FormGroup> : <FormGroup>
                        <Label>Commande existante (facultatif)</Label>
                        <Select
                            id="commandeNumero"
                            name="commandeNumero"
                            isClearable
                            placeholder={t('reception.selectOrder')}
                            options={poOptions}
                            isDisabled={values.statut === 'VALIDE'}
                            onChange={handlePurchaseOrderChange}
                            value={poOptions.find(option => option.value === values.commandeNumero)}
                            className="react-select"
                            classNamePrefix="select"
                            noOptionsMessage={() => t('reception.noOrderFound')}
                            loadingMessage={() => t('common.loading')}
                        />
                    </FormGroup>}
                </Col>
                <Col md="3">
                    <Label htmlFor="supplier">{t('purchase.supplier')}:</Label>
                    <Select
                        id="supplier"
                        name="supplier"
                        isClearable
                        placeholder={t('purchase.selectSupplier')}
                        options={fournisseurOptions}
                        isDisabled={values.statut === 'VALIDE'}
                        onChange={handleSupplierChange}
                        value={fournisseurOptions.find(option => option.value === values.fournisseurId)}
                        className="react-select"
                        classNamePrefix="select"
                        noOptionsMessage={() => t('purchase.noSupplierFound')}
                        loadingMessage={() => t('common.loading')}
                        components={{
                            DropdownIndicator: () => <FaUser className="me-2" />,
                            Option: ({ children, ...props }) => (
                                <components.Option {...props}>{children}</components.Option>
                            ),
                            MenuList: ({ children, ...props }) => (
                                <components.MenuList {...props}>
                                    {children}
                                    <div className="border-top p-2">
                                        <Button
                                            color="primary"
                                            size="sm"
                                            block
                                            onClick={handleCreateSupplier}
                                        >
                                            <FaPlus className="me-1" /> {t('supplier.new')}
                                        </Button>
                                    </div>
                                </components.MenuList>
                            )
                        }}
                    />
                    {formik.touched.fournisseurId && formik.errors.fournisseurId && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.fournisseurId}
                        </div>
                    )}
                </Col>
                <Col md="3">
                    <Label htmlFor="entrepotId">Lieu de stockage:</Label>
                    <Select
                        id="entrepotId"
                        options={entrepotOptions}
                        value={entrepotOptions.find(option => option.value === values.entrepotId)}
                        onChange={(selectedOption) => setFieldValue('entrepotId', selectedOption?.value || null)}
                        placeholder={t('commande.selectEntrepot')}
                        isSearchable
                        isDisabled={values.statut === 'VALIDE' ? true : false}
                    />
                    {touched.entrepotId && formik.errors.entrepotId && (
                        <div className="text-danger small mt-1">{formik.errors.entrepotId}</div>
                    )}
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Date de réception</Label>
                        <Input
                            type="date"
                            name="dateReception"
                            {...getFieldProps('dateReception')}
                            disabled={values.statut === 'VALIDE'}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Date comptable</Label>
                        <Input
                            type="date"
                            name="dateOperation"
                            {...getFieldProps('dateOperation')}
                            disabled={values.statut === 'VALIDE'}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>N° du bon fournisseur *</Label>
                        <Input
                            type="text"
                            name="deliveryNoteNb"
                            {...getFieldProps('deliveryNoteNb')}
                            disabled={values.statut === 'VALIDE'}
                        />
                        {formik.touched.deliveryNoteNb && formik.errors.deliveryNoteNb && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deliveryNoteNb}
                            </div>
                        )}
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label for="modeReglement">
                            <FaMoneyBillWave className="me-1" />
                            Paiement *
                        </Label>
                        <Input
                            type="select"
                            id="modeReglement"
                            name="modeReglement"
                            value={values.modeReglement}
                            disabled={values.statut === 'VALIDE'}
                            onChange={(e) => setFieldValue('modeReglement', e.target.value)}
                        >
                            <option value="">{t('common.select')}</option>
                            <option value="ESPECES">{t('facture.modeReglement.espece')}</option>
                            <option value="CHEQUE">{t('facture.modeReglement.cheque')}</option>
                            <option value="VIREMENT">{t('facture.modeReglement.virement')}</option>
                            <option value="CARTE_BANCAIRE">{t('facture.modeReglement.card')}</option>
                            <option value="TRAITE">{t('facture.modeReglement.traite')}</option>
                        </Input>
                    </FormGroup>
                </Col>
                {(values.modeReglement === 'CHEQUE') && (

                    <Col md={3}>
                        <FormGroup>
                            <Label for="numeroCheque">{t('reglement.numeroCheque')}</Label>
                            <Input
                                name="numeroCheque"
                                type="text"
                                className="form-control"
                                value={values.numeroCheque}
                                onChange={(e) => formik.setFieldValue('numeroCheque', e.target.value)}
                                disabled={values.statut !== 'EN_ATTENTE'}
                            />
                        </FormGroup>
                    </Col>)}
            </Row>
            </section>
            <section className="document-form-section document-form-lines-section">
                <div className="document-form-section-title">2. Articles reçus</div>
            <Row>
                <ReceptionLines formik={formik} />
                {formik.touched.lignes && formik.errors.lignes && (
                    <div className="invalid-feedback d-block">
                        {formik.errors.lignes}
                    </div>
                )}
            </Row>
            </section>
            <section className="document-form-section">
            <Row className="g-2 justify-content-end">
                <Col md={4}>
                    <FormGroup>
                        <Label htmlFor="montantRemise">Remise</Label>
                        <Input
                            id="montantRemise"
                            type="number"
                            min="0"
                            step="0.01"
                            value={values.montantRemise ?? 0}
                            onChange={handleDiscountChange}
                            onFocus={(event) => event.target.select()}
                            disabled={values.statut !== 'EN_ATTENTE' || discountLockedFromPurchase}
                        />
                    </FormGroup>
                    <div className="document-total-panel">
                        {Number(values.montantRemise) > 0 && <div><span>Avant remise</span><strong>{formatPrice(values.montantTotalAvantRemise ?? values.montantTotalTTC)}</strong></div>}
                        {Number(values.montantRemise) > 0 && <div><span>Remise</span><strong>{formatPrice(values.montantRemise ?? 0)}</strong></div>}
                        <p><strong>Total à payer :</strong> {formatPrice(values.montantTotalTTC)}</p>

                    </div>
                </Col>
            </Row>
            </section>
            <Row className="document-form-actions">
                <Col>
                    <Button type="submit" color="primary" className="me-2"
                        disabled={values.statut !== 'EN_ATTENTE'}
                    >
                        {t('common.save')}
                    </Button>
                    <Button type="button" color="secondary" onClick={closeForm}>{t('common.cancel')}</Button>
                </Col>
            </Row>
        </Form>
            </CardBody>
        </Card>
        <Modal isOpen={showSupplierModal} toggle={() => setShowSupplierModal(false)} size="lg" className="reception-compact-modal">
                <ModalHeader toggle={() => setShowSupplierModal(false)}>Nouveau fournisseur</ModalHeader>
                <ModalBody>
                    <FournisseurForm embedded onCancel={() => setShowSupplierModal(false)} onSaved={supplier => {
                        setFieldValue('fournisseurId', supplier.id);
                        setFieldValue('fournisseurNom', supplier.typeFournisseur === 'ENTREPRISE' ? supplier.entreprise : [supplier.nom, supplier.prenom].filter(Boolean).join(' '));
                        dispatch(supplierActions.search({ query: '' }));
                        setShowSupplierModal(false);
                    }} />
                </ModalBody>
            </Modal>
    </Container>
    );
};

export default ReceiptNoteNew;
